<template>
    <div class="pb-5">
        <h2 v-if="!isTab" v-html="$t('intern_userdata.title')"></h2>
        <p class="text-muted text-justify" v-if="!isTab" v-html="$t('intern_userdata.user_data_info')"></p>

        <!-- Address Details -->
        <h4  v-if="isTab" v-html="$t('intern_inserieren.tab_kontakt_titel')"></h4>
        <div v-if="isTab">
            <p>
                {{company}} <br>
                {{title}} {{title_ext}} {{forename}} {{surname}} <br>
                {{address}} {{address_ext}} <br>
                {{postcode}} {{city}} {{country}}<br>
                {{phone}}
            </p>
            <a class="mm-link" @click="toggleAddress">{{$t('intern_inserieren.rechnung_aendern')}}</a>
        </div>

        <!-- Display errors -->
        <div class="alert alert-danger" v-if="error" id="error_notification">
            {{error}}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="address-details" v-if="!toggleBillingAddress">
            <div class="row mt-3">
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="company">Firma</label>
                        <input type="text" id="company" v-model.trim="company" class="form-control">
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="title">Anrede</label>
                        <select v-model="title" id="title" class="form-control">
                            <option value=""></option>
                            <option value="Herr">Herr</option>
                            <option value="Frau">Frau</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="title_extra">Anredezusatz</label>
                        <input type="text" id="title_extra" v-model.trim="title_ext" class="form-control">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="forename">Vorname*</label>
                        <input type="text" id="forename" @blur="$v.forename.$touch()" v-model.trim="forename" :class="{ 'is-invalid': $v.forename.$error }" class="form-control">
                        <div class="invalid-feedback" v-if="!$v.forename.required">Bitte Vorname eingeben</div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="surname">Nachname*</label>
                        <input type="text" id="surname" @blur="$v.surname.$touch()" v-model.trim="surname" :class="{ 'is-invalid': $v.surname.$error }" class="form-control">
                        <div class="invalid-feedback" v-if="!$v.surname.required">Bitte Nachname eingeben</div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="address">Straße / Hausnummer*</label>
                        <input type="text" id="address" @blur="$v.address.$touch()" v-model.trim="address" :class="{ 'is-invalid': $v.address.$error }" class="form-control">
                        <div class="invalid-feedback" v-if="!$v.address.required">Bitte Straße / Hausnummer eingeben</div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="address_extra">Adresszusatz</label>
                        <input type="text" id="address_extra" v-model.trim="address_ext" class="form-control">
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="plz">PLZ*</label>
                        <input type="text" autocomplete="off"  id="plz" @input="getPlz()" v-model="postcode" :class="{ 'is-invalid': $v.postcode.$error }" class="form-control" placeholder="PLZ" @blur="[clearLocations(), $v.postcode.$touch()]">
                        <div class="invalid-feedback" v-if="!$v.postcode.required">Bitte PLZ eingeben</div>
                    </div>
                    <div style="position: absolute; z-index: 1;">
                        <ul class="list-group auto-complete" v-if="locations">
                            <li class="list-group-item" v-for="loc in locations" :key="loc.id" @click="selectPlz(loc.zip_code, loc.city, loc.id)">
                                {{loc.zip_code}} {{loc.city}}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="city">Ort*</label>
                        <input type="text" id="city" @blur="$v.city.$touch()" v-model="city" :class="{ 'is-invalid': $v.city.$error }" class="form-control">
                        <div class="invalid-feedback" v-if="!$v.city.required">Bitte Ort eingeben</div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="country">Land</label>
                        <input type="text" id="country" v-model.trim="country" class="form-control">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="phone">Telefon-Nummer</label>
                        <input type="text" id="phone" v-model.trim="phone" class="form-control">
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="mobile">Mobil-Nummer</label>
                        <input type="text" id="mobile" v-model.trim="mobile" class="form-control">
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-2">
                    <div class="form-group">
                        <label for="homepage">Homepage</label>
                        <input type="text" id="homepage" v-model.trim="homepage" class="form-control">
                    </div>
                </div>
            </div>
            <div class="mt-3">
                <button class="btn btn-success" @click="submit">Speichern</button>
            </div>
        </div>
        <loading v-if="loading"/>
        <b-toast id="my-toast" variant="success" solid>
            <b> {{success}} </b>
        </b-toast>
    </div>
</template>

<script>
    import { required } from 'vuelidate/lib/validators';

    export default {
        name: 'konto-adresse',
        props: {
            isTab: {
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                user: null,
                title: '',
                title_ext: '',
                company: '',
                forename: '',
                surname: '',
                address: '',
                address_ext: '',
                postcode: '',
                city: '',
                country: '',
                phone: '',
                mobile: '',
                homepage: '',
                loading: false,
                success: '',
                error: '',
                toggleBillingAddress: false,
                locations   : [],
                extra_locations: []
            }
        },
        methods: {
            submit() {
                this.$v.$touch();
                if(!this.$v.$invalid){
                    const data = {
                        title: this.title,
                        title_ext: this.title_ext,
                        company: this.company,
                        forename: this.forename,
                        surname: this.surname,
                        address: this.address,
                        address_ext: this.address_ext,
                        postcode: this.postcode,
                        city: this.city,
                        country: this.country,
                        phone: this.phone,
                        mobile: this.mobile,
                        homepage: this.homepage,
                    };
                    this.loading = true;
                    this.$http.post('/userApi/editUser', data).then((response) => {
                        this.loading = false;
                        if(response.status == 'success'){
                            let data = JSON.parse(response.data);
                            this.success = data.msg;
                            this.$bvToast.show('my-toast');
                            this.$store.dispatch('LOGIN_USER');
                            this.error = '';

                            if(this.isTab){
                                this.returnIfAddressExists();
                            }

                            this.$emit('ADDRESS_STORED');
                        }
                    }).catch(error => {
                        let data = JSON.parse(error.response.data.data);
                        this.error = data.msg;
                        this.scrollTop();
                        this.loading = false;
                    });
                }
                else{
                  this.scrollTop();
                }
            },
            scrollTop() {
                document.getElementById("company").scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
            },
            getPlz(main_location = true) {
                if(main_location){
                    this.$http.get('/objectApi/getPlz?term='+this.postcode).then((response) => {
                        this.locations = JSON.parse(response.data);
                    });
                }else {
                    this.$http.get('/objectApi/getPlz?term='+this.plz_2).then((response) => {
                        this.extra_locations = JSON.parse(response.data);
                    });
                }
            },
            selectPlz(plz, ort, id) {
                this.postcode = plz;
                this.city = ort;
                this.id  = id;
                this.locations = [];
            },
            clearLocations() {
                setTimeout(() => { this.locations = []; this.extra_locations = []; this.plz_2 = null;}, 500);
            },
            assignUser() {
                this.title = this.user.title;
                this.title_extra = this.user.title_ext;
                this.company = this.user.company;
                this.forename = this.user.forename;
                this.surname = this.user.surname;
                this.address = this.user.street;
                this.address_extra = this.user.address_ext;
                this.postcode = this.user.postcode;
                this.city = this.user.city;
                this.country = this.user.country;
                this.phone = this.user.phone;
                this.mobile = this.user.mobile;
                this.homepage = this.user.homepage;

                if(this.isTab){
                    this.returnIfAddressExists();
                }
            },
            toggleAddress() {
                this.toggleBillingAddress = !this.toggleBillingAddress;
            },
            returnIfAddressExists() {
                if(this.forename && this.surname && this.address && this.postcode && this.city){
                    this.$emit('initial', true);
                }
            }
        },
        mounted() {
            if(!this.isTab){
                document.title = 'Meine Adresse';
            }
            this.user = this.$store.getters.user;
            if(this.user != null){
                this.assignUser();
            }
            this.$store.watch( () => {
                    return this.$store.getters.user; // could also put a Getter here
                }, (user) =>{
                    this.user = user;
                    this.assignUser();
                }
            );

            if(this.isTab){
                this.toggleBillingAddress = true;
            }
        },
        validations: {
            forename: {required},
            surname: {required},
            address: {required},
            city: {required},
            postcode: {required},
        }
    }
</script>

<style scoped>

</style>
